import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ActivatedRoute } from '@angular/router';
import { PublicSocialNetworkPostControllerService } from 'src/app/api-client';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TranslocoService } from '@ngneat/transloco';
import { UploadComponent } from 'src/app/shared/components/upload/upload.component';

@Component({
  selector: 'app-social-network-post',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './send-social-network-post.component.html',
  styleUrls: ['./send-social-network-post.component.scss'],
})
export class SendSocialNetworkPostComponent {
  private companyUuid: string = '';
  private userUuid: string = '';

  private _publicSocialNetworkPostService = inject(
    PublicSocialNetworkPostControllerService
  );

  private _notification = inject(NotificationService);

  private _transloco = inject(TranslocoService);

  public loading: boolean = false;

  @ViewChild(UploadComponent) image: UploadComponent;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.companyUuid = params['companyId'];
      this.userUuid = params['userId'];
    });
  }

  public sendSocialNetworkRequest() {
    this.loading = true;
    this._publicSocialNetworkPostService
      .addClientSocialNetworkPost(
        {
          companyUuid: this.companyUuid,
          userUuid: this.userUuid,
        },
        this.image.uploadedFile
      )
      .subscribe({
        next: () => {
          this.loading = false;
          this._notification.success(
            this._transloco.translate(
              'socialNetwork.sendSocialNetworkPostSuccess'
            )
          );
          //Close tab after 1 second
          setTimeout(() => {
            window.close();
          }, 1000);
        },
        error: () => (this.loading = false),
      });
  }
}
